import { render, staticRenderFns } from "./pro-tree-icon.vue?vue&type=template&id=6a14a87d&scoped=true";
import script from "./pro-tree-icon.vue?vue&type=script&lang=js";
export * from "./pro-tree-icon.vue?vue&type=script&lang=js";
import style0 from "./pro-tree-icon.vue?vue&type=style&index=0&id=6a14a87d&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "6a14a87d", null);
export default component.exports;